export default [
  ...new Set([
    "Acne",
    "Acre",
    "Ad­den­dum",
    "Ad­ver­tise",
    "Air­craft",
    "Aisle",
    "Al­li­ga­tor",
    "Al­pha­bet­ize",
    "Amer­ica",
    "An­kle",
    "Ap­a­thy",
    "Ap­plause",
    "Ap­ple­sauc",
    "Ap­pli­ca­tion",
    "Ar­chae­ol­o­gist",
    "Aris­to­crat",
    "Arm",
    "Ar­mada",
    "Asleep",
    "As­tro­naut",
    "Ath­lete",
    "At­lantis",
    "Aunt",
    "Av­o­cado",
    "Baby-Sit­ter",
    "Back­bone",
    "Bag",
    "Baguette",
    "Bald",
    "Bal­loon",
    "Ba­nana",
    "Ban­is­ter",
    "Base­ball",
    "Base­boards",
    "Bas­ket­ball",
    "Bat",
    "Bat­tery",
    "Beach",
    "Bean-stalk",
    "Bed­bug",
    "Beer",
    "Bee­tho­ven",
    "Belt",
    "Bib",
    "Bi­cy­cle",
    "Big",
    "Bike",
    "Bill­board",
    "Bird",
    "Birth­day",
    "Bite",
    "Black­smith",
    "Blan­ket",
    "Bleach",
    "Blimp",
    "Blos­som",
    "Blue­print",
    "Blunt",
    "Blur",
    "Boa",
    "Boat",
    "Bob",
    "Bob­sled",
    "Body",
    "Bomb",
    "Bon­net",
    "Book",
    "Booth",
    "Bowtie",
    "Box",
    "Boy",
    "Brain­storm",
    "Brand",
    "Brave",
    "Bride",
    "Bridge",
    "Broc­coli",
    "Bro­ken",
    "Broom",
    "Bruise",
    "Bru­nette",
    "Bub­ble",
    "Buddy",
    "Buf­falo",
    "Bulb",
    "Bunny",
    "Bus",
    "Buy",
    "Cabin",
    "Cafe­te­ria",
    "Cake",
    "Cal­cu­la­tor",
    "Camp­site",
    "Can",
    "Canada",
    "Can­dle",
    "Candy",
    "Cape",
    "Cap­i­tal­ism",
    "Car",
    "Card­board",
    "Car­tog­ra­phy",
    "Cat",
    "Cd",
    "Ceil­ing",
    "Cell",
    "Cen­tury",
    "Chair",
    "Chalk",
    "Cham­pion",
    "Charger",
    "Cheer­leader",
    "Chef",
    "Chess",
    "Chew",
    "Chicken",
    "Chime",
    "China",
    "Choco­late",
    "Church",
    "Cir­cus",
    "Clay",
    "Cliff",
    "Cloak",
    "Clock­work",
    "Clown",
    "Clue",
    "Coach",
    "Coal",
    "Coaster",
    "Cog",
    "Cold",
    "Col­lege",
    "Com­fort",
    "Com­puter",
    "Cone",
    "Con­stric­tor",
    "Con­tin­uum",
    "Con­ver­sa­tion",
    "Cook",
    "Coop",
    "Cord",
    "Cor­duroy",
    "Cot",
    "Cough",
    "Cow",
    "Cow­boy",
    "Crayon",
    "Cream",
    "Crisp",
    "Crit­i­cize",
    "Crow",
    "Cruise",
    "Crumb",
    "Crust",
    "Cuff",
    "Cur­tain",
    "Cu­ti­cle",
    "Czar",
    "Dad",
    "Dart",
    "Dawn",
    "Day",
    "Deep",
    "De­fect",
    "Dent",
    "Den­tist",
    "Desk",
    "Dic­tio­nary",
    "Dim­ple",
    "Dirty",
    "Dis­man­tle",
    "Ditch",
    "Diver",
    "Doc­tor",
    "Dog",
    "Dog­house",
    "Doll",
    "Domi­noes",
    "Door",
    "Dot",
    "Drain",
    "Draw",
    "Dream",
    "Dress",
    "Drink",
    "Drip",
    "Drums",
    "Dryer",
    "Duck",
    "Dump",
    "Dunk",
    "Dust",
    "Ear",
    "Eat",
    "Ebony",
    "El­bow",
    "Elec­tric­ity",
    "Ele­phant",
    "El­e­va­tor",
    "Elf",
    "Elm",
    "En­gine",
    "Eng­land",
    "Er­go­nomic",
    "Es­ca­la­tor",
    "Eu­reka",
    "Eu­rope",
    "Evo­lu­tion",
    "Ex­ten­sion",
    "Eye­brow",
    "Fan",
    "Fancy",
    "Fast",
    "Feast",
    "Fence",
    "Feu­dal­ism",
    "Fid­dle",
    "Fig­ment",
    "Fin­ger",
    "Fire",
    "First",
    "Fish­ing",
    "Fix",
    "Fizz",
    "Flag­pole",
    "Flan­nel",
    "Flash­light",
    "Flock",
    "Flot­sam",
    "Flower",
    "Flu",
    "Flush",
    "Flut­ter",
    "Fog",
    "Foil",
    "Foot­ball",
    "Fore­head",
    "For­ever",
    "Fort­night",
    "France",
    "Freckle",
    "Freight",
    "Fringe",
    "Frog",
    "Frown",
    "Gal­lop",
    "Game",
    "Garbage",
    "Gar­den",
    "Gaso­line",
    "Gem",
    "Gin­ger",
    "Gin­ger­bread",
    "Girl",
    "Glasses",
    "Gob­lin",
    "Gold",
    "Good­bye",
    "Grandpa",
    "Grape",
    "Grass",
    "Grat­i­tude",
    "Gray",
    "Green",
    "Gui­tar",
    "Gum",
    "Gum­ball",
    "Hair",
    "Half",
    "Han­dle",
    "Hand­writ­ing",
    "Hang",
    "Happy",
    "Hat",
    "Hatch",
    "Headache",
    "Heart",
    "Hedge",
    "He­li­copter",
    "Hem",
    "Hide",
    "Hill",
    "Hockey",
    "Home­work",
    "Honk",
    "Hop­scotch",
    "Horse",
    "Hose",
    "Hot",
    "House",
    "House­boat",
    "Hug",
    "Hu­mid­i­fier",
    "Hun­gry",
    "Hur­dle",
    "Hurt",
    "Hut",
    "Ice",
    "Im­plode",
    "Inn",
    "In­qui­si­tion",
    "In­tern",
    "In­ter­net",
    "In­vi­ta­tion",
    "Ironic",
    "Ivory",
    "Ivy",
    "Jade",
    "Japan",
    "Jeans",
    "Jelly",
    "Jet",
    "Jig",
    "Jog",
    "Jour­nal",
    "Jump",
    "Key",
    "Killer",
    "Kilo­gram",
    "King",
    "Kitchen",
    "Kite",
    "Knee",
    "Kneel",
    "Knife",
    "Knight",
    "Koala",
    "Lace",
    "Lad­der",
    "La­dy­bug",
    "Lag",
    "Land­fill",
    "Lap",
    "Laugh",
    "Laun­dry",
    "Law",
    "Lawn",
    "Lawn­mower",
    "Leak",
    "Leg",
    "Let­ter",
    "Level",
    "Life­style",
    "Lig­a­ment",
    "Light",
    "Lightsaber",
    "Lime",
    "Lion",
    "Lizard",
    "Log",
    "Loi­terer",
    "Lol­lipop",
    "Love­seat",
    "Loy­alty",
    "Lunch",
    "Lunch­box",
    "Lyrics",
    "Ma­chine",
    "Ma­cho",
    "Mail­box",
    "Mam­moth",
    "Mark",
    "Mars",
    "Mas­cot",
    "Mast",
    "Match­stick",
    "Mate",
    "Mat­tress",
    "Mess",
    "Mex­ico",
    "Mid­sum­mer",
    "Mine",
    "Mis­take",
    "Mod­ern",
    "Mold",
    "Mom",
    "Mon­day",
    "Money",
    "Mon­i­tor",
    "Mon­ster",
    "Mooch",
    "Moon",
    "Mop",
    "Moth",
    "Mo­tor­cy­cle",
    "Moun­tain",
    "Mouse",
    "Mower",
    "Mud",
    "Mu­sic",
    "Mute",
    "Na­ture",
    "Ne­go­ti­ate",
    "Neigh­bor",
    "Nest",
    "Neu­tron",
    "Niece",
    "Night",
    "Night­mare",
    "Nose",
    "Oar",
    "Ob­ser­va­tory",
    "Of­fice",
    "Oil",
    "Old",
    "Olym­pian",
    "Opaque",
    "Opener",
    "Or­bit",
    "Or­gan",
    "Or­ga­nize",
    "Outer",
    "Out­side",
    "Ova­tion",
    "Over­ture",
    "Pail",
    "Paint",
    "Pa­ja­mas",
    "Palace",
    "Pants",
    "Pa­per",
    "Park",
    "Par­ody",
    "Party",
    "Pass­word",
    "Pas­try",
    "Pawn",
    "Pear",
    "Pen",
    "Pen­cil",
    "Pen­du­lum",
    "Pe­nis",
    "Penny",
    "Pep­per",
    "Per­sonal",
    "Phi­los­o­pher",
    "Phone",
    "Pho­to­graph",
    "Pi­ano",
    "Pic­nic",
    "Pig­pen",
    "Pil­low",
    "Pi­lot",
    "Pinch",
    "Ping",
    "Pin­wheel",
    "Pi­rate",
    "Plaid",
    "Plan",
    "Plank",
    "Plate",
    "Platy­pus",
    "Play­ground",
    "Plow",
    "Plumber",
    "Pocket",
    "Poem",
    "Point",
    "Pole",
    "Pomp",
    "Pong",
    "Pool",
    "Pop­si­cle",
    "Pop­u­la­tion",
    "Port­fo­lio",
    "Pos­i­tive",
    "Post",
    "Prin­cess",
    "Pro­cras­ti­nate",
    "Protes­tant",
    "Psy­chol­o­gist",
    "Pub­lisher",
    "Punk",
    "Pup­pet",
    "Puppy",
    "Push",
    "Puz­zle",
    "Quar­an­tine",
    "Queen",
    "Quick­sand",
    "Quiet",
    "Race",
    "Ra­dio",
    "Raft",
    "Rag",
    "Rain­bow",
    "Rain­wa­ter",
    "Ran­dom",
    "Ray",
    "Re­cy­cle",
    "Red",
    "Re­gret",
    "Re­im­burse­ment",
    "Re­tal­i­ate",
    "Rib",
    "Rid­dle",
    "Rim",
    "Rink",
    "Roller",
    "Room",
    "Rose",
    "Round",
    "Round­about",
    "Rung",
    "Runt",
    "Rut",
    "Sad",
    "Safe",
    "Salmon",
    "Salt",
    "Sand­box",
    "Sand­cas­tle",
    "Sand­wich",
    "Sash",
    "Satel­lite",
    "Scar",
    "Scared",
    "School",
    "Scoun­drel",
    "Scram­ble",
    "Scuff",
    "Seashell",
    "Sea­son",
    "Sen­tence",
    "Se­quins",
    "Set",
    "Shaft",
    "Shal­low",
    "Sham­poo",
    "Shark",
    "Sheep",
    "Sheets",
    "Sher­iff",
    "Ship­wreck",
    "Shirt",
    "Shoe­lace",
    "Short",
    "Shower",
    "Shrink",
    "Sick",
    "Siesta",
    "Sil­hou­ette",
    "Singer",
    "Sip",
    "Skate",
    "Skat­ing",
    "Ski",
    "Slam",
    "Sleep",
    "Sling",
    "Slow",
    "Slump",
    "Smith",
    "Sneeze",
    "Snow",
    "Snug­gle",
    "Song",
    "Space",
    "Spare",
    "Speak­ers",
    "Spi­der",
    "Spit",
    "Sponge",
    "Spool",
    "Spoon",
    "Spring",
    "Sprin­kler",
    "Spy",
    "Square",
    "Squint",
    "Stairs",
    "Stand­ing",
    "Star",
    "State",
    "Stick",
    "Stock­holder",
    "Stop­light",
    "Stout",
    "Stove",
    "Stow­away",
    "Straw",
    "Stream",
    "Stream­line",
    "Stripe",
    "Stu­dent",
    "Sun",
    "Sun­burn",
    "Sushi",
    "Swamp",
    "Swarm",
    "Sweater",
    "Swim­ming",
    "Swing",
    "Ta­chom­e­ter",
    "Talk",
    "Taxi",
    "Teacher",
    "Teapot",
    "Teen­ager",
    "Tele­phone",
    "Ten",
    "Ten­nis",
    "Thief",
    "Think",
    "Throne",
    "Through",
    "Thun­der",
    "Tide",
    "Tiger",
    "Time",
    "Tint­ing",
    "Tip­toe",
    "Tip­top",
    "Tired",
    "Tis­sue",
    "Toast",
    "Toi­let",
    "Tool",
    "Tooth­brush",
    "Tor­nado",
    "Tour­na­ment",
    "Trac­tor",
    "Train",
    "Trash",
    "Trea­sure",
    "Tree",
    "Tri­an­gle",
    "Trip",
    "Truck",
    "Tub",
    "Tuba",
    "Tu­tor",
    "Tele­vi­sion",
    "Twang",
    "Twig",
    "Twit­ter­pated",
    "Type",
    "Un­em­ployed",
    "Up­grade",
    "Vest",
    "Vi­sion",
    "Wag",
    "Wa­ter",
    "Wa­ter­melon",
    "Wax",
    "Wed­ding",
    "Weed",
    "Welder",
    "What­ever",
    "Wheel­chair",
    "Whip­lash",
    "Whisk",
    "Whis­tle",
    "White",
    "Wig",
    "Will",
    "Wind­mill",
    "Win­ter",
    "Wish",
    "Wolf",
    "Wool",
    "World",
    "Worm",
    "Wrist­watch",
    "Yard­stick",
    "Zam­boni",
    "Zen",
    "Zero",
    "Zip­per",
    "Zone",
    "Zoo"
  ])
];
